import { postAPI } from '@/services-ts/axios'
import type { IGetCollageList, IPayloadCollage } from '@/types/Request/PostAPI'
import type { ICollageStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useCollageStore = defineStore('collage', {
  state: (): ICollageStore => ({
    collageList: {
      data: [],
      total: 0,
    },
  }),

  actions: {
    async GetCollageList(payload: IGetCollageList) {
      const { status, data, total } = await postAPI.CollageServices.GetCollageList(payload)
      this.collageList = status ? { data, total: total || 0 } : { data: [], total: 0 }
    },

    async CreateCollage(payload: IPayloadCollage) {
      const { status, data } = await postAPI.CollageServices.CreateCollage(payload)

      if (status) {
        this.collageList.data.push(data)
        this.collageList.total += 1
        void Alert({ type: 'success', message: Format('admin_global_success') })
      }

      return status
    },

    async UpdateCollage(payload: IPayloadCollage) {
      const { status, data } = await postAPI.CollageServices.UpdateCollage(payload)

      if (status) {
        const index = this.collageList.data.findIndex(item => item.id === payload.Id)
        if (index !== -1) this.collageList.data[index] = data

        void Alert({ type: 'success', message: Format('admin_global_updated') })
      }
      return status
    },

    async DeleteCollage(Id: string) {
      const { status } = await postAPI.CollageServices.DeleteCollage(Id)

      if (status) {
        this.collageList.data = this.collageList.data.filter(item => item.id !== Id)
        void Alert({ message: Format('admin_global_deleted'), type: 'success' })
      }
    },
  },
})
